/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as o from "react";
import { clientColumn as C, resolveCells as u, isClientReference as f } from "../utils/index.mjs";
import { classNames as p } from "@progress/kendo-react-common";
import { FooterCellContainer as s } from "./client/FooterCellContainer.mjs";
const v = (t) => {
  const { column: e, index: n, cells: m } = t, l = {
    colSpan: e.colSpan !== 1 ? e.colSpan : void 0,
    className: p("k-table-td", e.locked && e.left !== void 0 ? "k-grid-footer-sticky" : ""),
    role: "gridcell",
    "aria-colindex": e.ariaColumnIndex
  }, a = {
    field: e.field,
    ariaColumnIndex: e.ariaColumnIndex,
    ...l
  }, c = C(e), r = u(m, e.cells);
  if (r && r.footerCell) {
    const i = r.footerCell, d = f(i);
    return /* @__PURE__ */ o.createElement(
      s,
      {
        key: n,
        id: t.id,
        tdProps: l,
        isCustom: !0,
        isClient: d,
        column: c
      },
      /* @__PURE__ */ o.createElement(i, { ...a, tdProps: l, index: n })
    );
  }
  return /* @__PURE__ */ o.createElement(s, { key: n, id: t.id, column: c }, /* @__PURE__ */ o.createElement("td", { ...l }));
};
export {
  v as FooterCell
};
